import styled from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

export const EnhancedItemName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const Indent = styled.div`
  width: 40px;
  height: 40px;

  ${mediaQueries.tablet} {
    width: 60px;
    height: 60px;
  }
`
